import { Component } from '@angular/core';

import { ListDevicesComponent } from './list-devices/list-devices.component';
@Component({
    selector: 'app-devices',
    templateUrl: './devices.component.html',
    styleUrls: ['./devices.component.css'],
    imports: [ListDevicesComponent]
})
export class DevicesComponent {

}
